import React, {useState} from 'react';
import {
    Box,
    Button,
    Dialog,
    Grid, IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Tooltip,
} from '@mui/material';
import {
    useCreateChargeV2Mutation,
    useDeleteChargeV2Mutation,
    useGetChargesTypesV2Query,
    useUpdateChargeV2Mutation
} from "../../../core/api/charge-api";
import Loading from "../../../components/Common/Loading";
import CreateUpdateModal from "./createUpdateModal";
import {useParams} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";


const ChargeManagement = (props) => {
    const [charge, setCharge] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);

    const {game} = useParams()

    const [createCharge] = useCreateChargeV2Mutation();
    const [updateCharge] = useUpdateChargeV2Mutation();
    const [deleteCharge] = useDeleteChargeV2Mutation();

    const params = useParams();

    const [updateMode, setUpdateMode] = useState(false);
    const [createMode, setCreateMode] = useState(false);

    const handleCancel = () => {
        setUpdateMode(false);
        setCreateMode(false);
        setDeleteMode(false);
    }

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetChargesTypesV2Query(game)


    const handleEditCharge = (item) => {
        setCharge(item)
        setUpdateMode(true);
    };

    const handleCreateCharge = () => {
        setCharge({
            name: "",
            value: "",
            key: "",
            key2: "",
            guidMap: "",
            guidMap2: "",
            amount: false,
            amountAttribute: "count",
            endTime: false,
            id: ""
        })
        setCreateMode(true);
    };

    const handleChargeAction = () => {
        const newCharge = {
            ...charge,
            "gameName": game
        };
        if (updateMode) {
            updateCharge({data: newCharge, game: params.game})
            handleCancel();
        } else if (createMode) {
            createCharge({data: newCharge, game: params.game});
            handleCancel();
        }
    }

    const handleDeleteCharge = (index) => {
        setCharge(data[index])
        setDeleteMode(true);
    };

    const handleDeleteAction = () => {
        deleteCharge({id: charge.id, game: params.game});
        handleCancel();
    }

    return (
        <>
            <h1>Charge Management</h1>

            <Button
                sx={{mb:1}}
                variant="outlined"
                
                    onClick={() => handleCreateCharge()}
            >
                Add Charge
            </Button>
            <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}>
                <DataGrid
                    rows={isSuccess ? data : []}
                    getRowId={(row) => row.id}
                    loading={isLoading}
                    disableRowSelectionOnClick
                    columns={[
                        { field: "name", headerName: "Name", flex: 1, align: "center", headerAlign: "center" },
                        { field: "value", headerName: "Value", flex: 1, align: "center", headerAlign: "center" },
                        { field: "key", headerName: "Key", flex: 1, align: "center", headerAlign: "center" },
                        { field: "key2", headerName: "Key 2", flex: 1, align: "center", headerAlign: "center" },
                        { field: "guidMap", headerName: "Guid map", flex: 1, align: "center", headerAlign: "center" },
                        { field: "guidMap2", headerName: "Guid map 2", flex: 1, align: "center", headerAlign: "center" },
                        { field: "gameName", headerName: "Game Name", flex: 1, align: "center", headerAlign: "center" },
                        {
                            field: "amount",
                            headerName: "Amount",
                            flex: 1,
                            align: "center",
                            headerAlign: "center",
                            renderCell: (params) => (params.value ? "Yes" : "No"),
                        },
                        {
                            field: "endTime",
                            headerName: "End Time",
                            flex: 1,
                            align: "center",
                            headerAlign: "center",
                            renderCell: (params) => (params.value ? "Yes" : "No"),
                        },
                        {
                            field: "duration",
                            headerName: "Duration",
                            flex: 1,
                            align: "center",
                            headerAlign: "center",
                            renderCell: (params) => (params.value ? "Yes" : "No"),
                        },
                        {
                            field: "edit",
                            headerName: "",
                            sortable: false,
                            filterable: false,
                            width: 100,
                            renderCell: (params) => (
                                <Button
                                    variant="text"
                                    onClick={() => handleEditCharge(params.row)}
                                >
                                    Edit
                                </Button>
                            ),
                        },
                        {
                            field: "delete",
                            headerName: "",
                            sortable: false,
                            filterable: false,
                            width: 100,
                            renderCell: (params) => (
                                <Tooltip title="Delete">
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() =>
                                            handleDeleteCharge(
                                                data.findIndex((x) => x.id === params.row.id)
                                            )
                                        }
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                            ),
                        },
                    ]}
                />

            </Loading>
            <Dialog
                open={updateMode || createMode}
                onClose={handleCancel}>

                <CreateUpdateModal
                    setCharge={setCharge}
                    charge={charge}
                    handleChargeAction={handleChargeAction}
                    handleCancel={handleCancel}
                />

            </Dialog>
            <Dialog
                open={deleteMode}
                onClose={handleCancel}>
                <Box sx={{margin: 5}}>
                    <h2>Are you sure you want to delete charge {charge?.name}?</h2>
                    <Grid container spacing={2}>
                        <Grid xs={12} size={3}>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid size={3}>
                            <Button variant="contained"
                                    onClick={handleDeleteAction}
                            >
                                Delete
                            </Button>
                        </Grid>
                        <Grid size={3}>
                            <Button variant="outlined"
                                    onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Dialog>
        </>
    );
};

export default ChargeManagement;
